export const mapInvoiceToTable = (invoices, currency) => {

  if (!Array.isArray(invoices)) return [];
  return invoices.map((inv) => ({
    id: inv.exportInvoiceId || "", // Table row id
    exportInvoiceId: inv?.exportInvoiceId || "", // ✅ This is needed!
    exportCurrencyId: inv?.exportCurrencyId || "", // ✅ This also!
    name: inv.exportInvoiceNumber || "",
    Currency: inv.currencyCode || "",
    CurrencyCurrentValue: inv.currencyValue || 0,
    exportInvoiceValue: inv.exportInvoiceValue || 0,
    TOIPlace: inv.exportInvoiceTOI || "",
    Places: inv.exportInvoiceTOIPlace || "",
    PackingFOB: inv.exportInvoicePackingorFob || "",
    Date: inv.exportInvoiceEntryDate || "",
    PriceIncludes: inv.exportinvoicepriceicludes || "",
    ProductValue: inv.exportInvoiceproductvalue || 0,
    TaxablevalueforIGST: inv.exportInvicetaxablevalue || 0,
  }));
};


export const mapFormToInvoiceAPI = (data) => ({
  invoice: {
    exportInvoiceId: data.id || "",
    exportInvoiceNumber: data.InvoiceNumber || "",
    name: data.Currency || "",
    exportInvoiceTOIAndPlace: data.Places || "",
    exportinvoicepriceicludes: data.PriceIncludes || "",
    exportInvicetaxablevalue: Number(data.TaxablevalueforIGST) || 0,
    exportInvoiceValue: Number(data.exportInvoiceValue) || 0,
    exportInvoiceproductvalue: Number(data.ProductValue) || 0,
    exportInvoicePackingorFob: data.PackingFOB || "",
    exportCurrencyId: data?.currencyId || "", 
  },
});


